import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { Router } from "@angular/router";
import {
  NbComponentStatus,
  NbDialogService,
  NbGlobalPhysicalPosition,
  NbToastrService,
} from "@nebular/theme";

import { convertTimestamp } from "../../@core/utils/convertTimestamps.service";

import { replace, remove, clone, find } from "lodash";
import { Supplier } from "../../models/supplier.model";

import { SupplierService } from "../../services/supplier.service";

import { DialogSupplierComponent } from "../dialog-supplier/dialog-supplier.component";
import { UserService } from "../../@core/services/user.service";
import { User } from "../../@core/data/users";
import { map, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

@Component({
  selector: "ngx-view-suppliers",
  styleUrls: ["./view-suppliers.component.scss"],
  templateUrl: "./view-suppliers.component.html",
})
export class ViewSuppliersComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  private destroy$: Subject<void> = new Subject<void>();
  @Input() mode?: string = ""; //admin / develop
  @Input() shopId?: string = "";
  suppliers?: Supplier[] = [];
  supplier: Supplier = new Supplier();

  loading = false;
  submitted = false;
  diaForm: FormGroup;

  strSearch = "";
  uid = "anonymous";

  companyId = "anonymous";
  @ViewChild("title") title: ElementRef;
  @ViewChild("mobile") mobile: ElementRef;
  isMoreInfo = true;

  constructor(
    private userService: UserService,
    private supplierService: SupplierService,
    private router: Router,
    private fb: FormBuilder,
    private dialogService: NbDialogService,
    private toastrService: NbToastrService
  ) {}

  ngOnInit(): void {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;
          this.companyId = user.companyId;

          if (!this.shopId || this.shopId == "") {
            this.shopId = user.shopId;
          }
        } else {
          this.uid = "anonymous";
          this.companyId = "anonymous";
        }
        this.getSuppliers();
      });

    const fullNameValidators = [
      Validators.minLength(1),
      Validators.maxLength(250),
      Validators.required,
    ];
    const mobileValidators = [
      Validators.minLength(9),
      Validators.maxLength(11),
      Validators.required,
    ];
    this.diaForm = this.fb.group({
      fullName: ["", fullNameValidators],
      mobile: ["", mobileValidators],
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.isMoreInfo = false;
      this.title.nativeElement.focus();
    }, 1000);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  //Quick create supplier
  inputMore() {
    this.isMoreInfo = !this.isMoreInfo;
  }

  inputMobile() {
    if (this.isMoreInfo) {
      this.mobile.nativeElement.focus();
    }
  }

  //load data
  getSuppliers() {
    this.loading = true;
    this.supplierService
      .getSuppliers(this.shopId)
      .snapshotChanges(["added", "removed"])
      .pipe(
        map((changes) =>
          changes.map((c) => ({
            id: c.payload.doc.id,
            ...c.payload.doc.data(),
            dob: c.payload.doc.data().dob
              ? convertTimestamp(c.payload.doc.data().dob)
              : null,
          }))
        ),
        takeUntil(this.destroy$)
      )
      .subscribe((data) => {
        this.suppliers = data;

        console.log("getSuppliers:", this.suppliers);

        this.loading = false;
      });
  }

  create() {
    this.supplier.shopId = this.shopId;
    this.supplier.fullName = this.supplier.fullName
      ? this.supplier.fullName.trim()
      : "";
    this.supplier.mobile = this.supplier.mobile
      ? this.supplier.mobile.trim()
      : "";

    if (this.supplier.fullName.length > 0) {
      this.loading = true;
      this.submitted = true;

      this.supplierService
        .create(this.supplier)
        .then((data) => {
          this.supplier = new Supplier();
          this.title.nativeElement.focus();

          this.loading = false;
          this.submitted = false;
        })
        .catch((err) => {
          this.loading = false;
          this.submitted = false;
        });
    }
  }

  onNew() {
    this.dialogService
      .open(DialogSupplierComponent, {
        context: {
          header: "Tạo nhà cung cấp",
          mode: "new",
          shopId: this.shopId,
          supplier: this.supplier,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.supplier = new Supplier();
        }
      });
  }

  onEdit(item: Supplier) {
    if (item) {
      for (let i = 0; i < this.suppliers.length; i++) {
        if (this.suppliers[i].id == item.id) {
          this.suppliers[i] = item;
          break;
        }
      }
    }
  }

  onDelete(value) {
    remove(this.suppliers, (e) => {
      return e.id == value;
    });
  }

  //Control event
  private showToast(type: NbComponentStatus, title: string, body: string) {
    const config = {
      status: type,
      destroyByClick: true,
      duration: 2000,
      hasIcon: true,
      position: NbGlobalPhysicalPosition.TOP_RIGHT,
      preventDuplicates: false,
    };
    const titleContent = title ? `${title}` : "";

    this.toastrService.show(body, titleContent, config);
  }
}
